<script lang="ts">
  import Skin from "../assets/bo7-skin.webp";
  import Points from "../assets/cod-points.webp";
  import RegistrationForm from "../components/RegistrationForm.svelte";
  import { copy } from "../lib/stores/copy";
  import Emblem from "../assets/emblem_v2.webp";
  import Charm from "../assets/charm_v2.webp";
  import CallingCard from "../assets/calling_card_v2.webp";
  import { route } from "../lib/stores/route";
  import MobilePrizes from "../components/MobilePrizes.svelte";
  import { isPrimaryCampaign } from "../lib/constants/countries";
  import PrizeRewards from "../components/PrizeRewards.svelte";
</script>

<main class="bg-cover bg-no-repeat bg-[center_top] bg-[url('/bg/mobile-bg51.webp')] tablet:bg-[url('/bg/primary-bg.webp')] tabletLg:bg-none tabletLg:bg-dark flex-col grow relative bg-dark overflow-y-hidden" class:hidden={$route.isLoading}>
  <div class="flex grow">
    <div class="flex justify-center flex-col w-full">
      <div class={[
        "relative flex overflow-hidden items-center justify-center w-full grow",
        "py-[32px]",
        "tabletLg:pt-[160px] tabletLg:pb-[140px]",
        "tabletLg:bg-[url('/bg/primary-bg.webp')] tabletLg:bg-cover tabletLg:bg-[position:top_center] tabletLg:bg-no-repeat",
        "before:content-[''] before:absolute before:bottom-0 before:left-0 before:right-0 before:h-[100px]",
        "tabletLg:before:bg-gradient-to-b tabletLg:before:from-transparent tabletLg:before:to-dark",
        "before:pointer-events-none before:z-[1]"
      ].join(' ')}>
        {#if !isPrimaryCampaign}
          <PrizeRewards includeMB8={true} />
        {/if}
        {#if isPrimaryCampaign}
          <div class="absolute left-0 h-full hidden tabletLg:block w-[30vw] max-w-[400px]">
            <div class="relative left-[-8%] bottom-[-2%] pointer-events-none">
              <div class="relative">
                <img src={Skin} alt="" class="w-full">
              </div>
              <div class="font-MrEavesXLSanNarOTUltra absolute left-[65%] whitespace-nowrap top-[12%] text-[13px] text-white font-black uppercase diffuse-text-shadow laptop:text-[15px] desktopLg:text-[17px]">
                {$copy.prizeNames.operatorSkin}
              </div>
              {#if isPrimaryCampaign}
                <div class="absolute w-[70%] top-[34%] left-[55%]">
                  <div class="font-MrEavesXLSanNarOTUltra absolute left-[10%] top-0 text-[13px] text-white font-black uppercase diffuse-text-shadow laptop:text-[15px] desktopLg:text-[17px]">
                    {@html $copy.prizeNames.codPoints}
                  </div>
                  <div class="std-register__points-img">
                    <img src={Points} alt="" class="relative z-[2]">
                  </div>
                </div>
              {/if}
            </div>
          </div>
        {/if}
        <div class="tabletLg:max-w-[calc(75vw-400px)] z-[5]">
          <div class="mb-[24px] text-center p-4 bg-black/50 rounded-md my-4">
            <h1 class="font-MrEavesXLSanNarOTUltra font-black flex flex-col items-center text-primary whitespace-normal leading-[0.75] uppercase text-shadow mb-[14px] text-[48px] tablet:block laptop:mb-[20px] mobileS:text-[48px] mobile:text-[48px] tablet:text-[84px] tabletLg:text-[60px] laptop:text-[84px] desktopLg:text-[105px]">
              {@html $copy.registration.title}
            </h1>
            <h2 class="font-MrEavesXLSanNarOTUltra text-[19px] leading-[1] mb-[8px] uppercase text-white font-black text-shadow mobile:text-[24px] tablet:text-[24px] laptop:text-[29px] desktop:text-[32px] desktopLg:text-[35px]">
              {$copy.registration.subtitle}
            </h2>
            {#if !isPrimaryCampaign}
              <div class="font-MrEavesXLSanNarOT text-[18px] text-white text-center laptop:text-[15px] desktop:text-[18px] desktopLg:text-[21px]">
                {$copy.registration.limitedToThreeTotalQualifyingPurchases}
              </div>
            {/if}
            <div class="font-MrEavesXLSanNarOT text-[18px] text-white text-center laptop:text-[15px] desktop:text-[18px] desktopLg:text-[21px]">
              <span class="reg text-[0.7em] align-top">*</span>{$copy.registration.requiredField}
            </div>
          </div>
        </div>
        {#if isPrimaryCampaign}
          <div class="absolute right-[36px] hidden tabletLg:block top-0 max-w-[500px]">
            <div class="flex justify-center">
              <div class="flex items-end justify-center flex-row">
                <div class="text-center mx-[4px]">
                  <div class="font-MrEavesXLSanNarOTUltra text-[13px] text-white font-black mb-[8px] uppercase diffuse-text-shadow laptop:text-[15px] desktopLg:text-[17px]">
                    {$copy.prizeNames.emblem}
                  </div>
                  <img src={Emblem} alt="" class="w-[150px]">
                </div>
                <div class="text-center mx-[4px] relative">
                  <div class="absolute top-[30%] left-[60%] translate-y-[-50%] font-MrEavesXLSanNarOTUltra text-[13px] text-white font-black uppercase diffuse-text-shadow laptop:text-[15px] desktopLg:text-[17px] leading-[1]">
                    {$copy.prizeNames.charm}
                  </div>
                  <img src={Charm} alt="" class="w-[120px]">
                </div>
              </div>
            </div>
            <div class="w-[26vw] max-w-[400px] text-right mt-[24px]">
              <div class="font-MrEavesXLSanNarOTUltra text-[13px] text-white mb-[4px] font-black uppercase diffuse-text-shadow laptop:text-[15px] desktopLg:text-[17px]">
                {$copy.prizeNames.callingCard}
              </div>
              <img src={CallingCard} alt="">
            </div>
            {#if isPrimaryCampaign}
              <p class="font-MrEavesXLSanNarOTUltra text-[18px] text-white font-black mb-[12px] leading-[0.9] uppercase diffuse-text-shadow mt-[32px] text-center tablet:mt-[42px] tablet:text-[19px] laptop:text-[24px] desktop:text-[30px] desktopLg:text-[37px]">
              <span class="font-LCScript text-primary capitalize leading-[0.75]">{@html $copy.prizeNames.plus}</span>
                {@html $copy.prizeNames.youCanWinSplit}
              </p>
            {/if}
          </div>
        {/if}
      </div>
      <RegistrationForm />
      <MobilePrizes isRegister={true} />
    </div>
  </div>
</main>
